import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { CreateCheckoutLinkSchema } from "schema"
import { z } from "zod"

type Props = z.infer<typeof CreateCheckoutLinkSchema>
type Response = { data: { url: string }; error: string | null }

export function useCreateCheckoutSessionMutation() {
  return useMutation({
    mutationFn: async (data: Props) => {
      const response = await axios.post<Response>("/billing/checkout", data)
      return response.data.data.url
    },
  })
}
